import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PnrInfo } from 'src/app/core/models/itinerary.model';
import { IReRouteQuoteRequest } from 'src/app/core/models/re-route.model';
import { Config } from 'src/environments/config.model';
import { environment } from 'src/environments/environment';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export class ReRouteAPIService {
  env: Config = environment;
  api = this.env.urlBase;

  constructor(private http: HttpClient) {}

  postReRouteNoShowRequest(reRouteQuoteRequest: IReRouteQuoteRequest): Observable<PnrInfo> {
    reRouteQuoteRequest.overSign =
      reRouteQuoteRequest?.overSign?.username && reRouteQuoteRequest?.overSign?.password
        ? reRouteQuoteRequest.overSign
        : null;
    const urlRequest = `${this.api}${this.env.involuntaryNoShowRegulation}/logData/reportLogFront/requestInvoluntaryNoShowRegulation/${reRouteQuoteRequest.pnr}/${reRouteQuoteRequest.gds}/${reRouteQuoteRequest.bookingCode}`;
    return this.http.post<PnrInfo>(urlRequest, reRouteQuoteRequest, httpOptions);
  }
}
